import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'cs2-competitive',
  templateUrl: './cs2-competitive.component.html'
})
export class Cs2CompetitiveComponent {
  service = 'masteries';
  availableServices = services['cs2'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'cs2',
    service: 'masteries',
    type: 'solo',
    title: {
      en: 'Competitive Boosting',
    },
    queue: 'competitive',
    subtitle: {
      en: "Get your Desired Counter Strike 2 Competitive Rank in Solo or Duo Boosting",
      fr: "Obtenez le rang compétitif que vous souhaitez sur Counter Strike 2 en boostant en solo ou en duo",
      de: "Erreiche deinen gewünschten Counter Strike 2 Competitive Rang im Solo oder Duo Boosting",
      pt: "Alcança o Competitive rank desejado para Counter Strike 2 em Solo ou Duo Boosting",
      es: "Consigue tu rango competitivo deseado en Counter Strike 2 en Solo o Duo Boosting",
    },
    start: 5,
    desired: 10,
    map: 'Dust2'
  }

  serviceFaqs = {
    en: [
      {
        question: "What Exactly Is A CS2 Competitive Rank Boost Service?",
        answer: "A Premier Boosting service is the best way to guarantee that top-tier boosters will obtain your desired CS Rating."
      },
      {
        question: "Can I Play With The Booster In Duo While Boosting?",
        answer: "Certainly! You can accomplish that by clicking the \"DUO\" red button found in the order additions menu."
      },
      {
        question: "What If I Demote Before The Service Is Complete?",
        answer: "Our services are 100% guaranteed. If any issues arise, we will quickly fix them and ensure you reach your target Rank."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you wish to play Competitive on the map associated with the purchased service. In the case of any other mode or map, simply pause or schedule with your booster and have fun!"
      },
      {
        question: "Can I Pick My Booster Schedule?",
        answer: "Yes, you can. When you place an order you can add your schedule as a note to your booster, or you can discuss any details with your booster, including setting up a schedule., on the order chat."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce que le service de boost de rang compétitif CS2?",
        answer: "Un service de Boosting Compétitif est le meilleur moyen de garantir que les meilleurs boosters obtiendront le classement CS que vous souhaitez."
      },
      {
        question: "Puis-je jouer en duo avec le booster pendant que je booste?",
        answer: "Certainement ! Vous pouvez le faire en cliquant sur le bouton rouge \"DUO\" qui se trouve dans le menu des ajouts à la commande."
      },
      {
        question: "Que se passe-t-il si je rétrograde avant la fin du service?",
        answer: "Nos services sont garantis à 100 %. Si un problème survient, nous le réglerons rapidement et nous nous assurerons que vous atteignez votre rang cible."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Oui, sauf si vous souhaitez jouer en mode compétitif sur la map associée au service acheté. Dans le cas d\'un autre mode ou d\'une autre map, mettez simplement en pause ou planifiez avec votre booster et faites-vous plaisir!"
      },
      {
        question: "Puis-je choisir le planning de mon booster?",
        answer: "Oui, vous le pouvez. Lorsque vous passez une commande, vous pouvez ajouter votre planning sous forme de note à votre booster, ou vous pouvez discuter de tous les détails avec votre booster, y compris la mise en place d\'un planning, sur le chat de la commande."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was genau ist ein CS2 Competitive Rank Boost Service?",
        answer: "Ein Competitive Boosting Service ist der beste Weg, um sicherzustellen, dass Top-Player deinen gewünschten CS-Rang erreichen."
      },
      {
        question: "Kann ich mit dem Booster im Duo spielen, während ich booste?",
        answer: "Aber sicher! Dazu klickst du auf die Schaltfläche \"Duo\" im Menü der Bestellungszusätze "
      },
      {
        question: "Was passiert, wenn ich vor Abschluss des Services degradiere?",
        answer: "Unser Service ist zu 100% garantiert. Sollten dennoch Probleme auftreten, werden wir diese schnellstmöglich beheben und dafür sorgen, dass du dein Ziel erreichst."
      },
      {
        question: "Kann ich spielen, während der Auftrag aktiv ist?",
        answer: "Ja, es sei denn, du möchtest Competitive auf der Karte spielen, die mit dem Service verbunden ist, den du gekauft hast. Wenn du einen anderen Modus oder eine andere Karte verwendest, pausiere oder plane mit deinem Booster und habe Spaß!"
      },
      {
        question: "Kann ich meinen Booster-Zeitplan selbst bestimmen?",
        answer: "Ja, das kannst du. Wenn du bestellst, kannst du deinen Stundenplan als Notiz an deinen Booster anhängen oder alle Details mit deinem Booster im Bestellchat besprechen, inklusive Stundenplanerstellung."
      },
      {
        question: "Kann ich denselben Booster für zukünftige Käufe anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O Que É Um Serviço De Competitive Rank Boost Em CS2?",
        answer: "Competitive rank boost é a melhor maneira de garantir que obténs o rank desejado em modo Competitive."
      },
      {
        question: "Posso jogar com o Booster em Duo enquanto faço o Boosting?",
        answer: "Certamente! Podes fazer isso ao clicar no botão vermelho \"DUO\" que se encontra no menu de adições do pedido."
      },
      {
        question: "O Que Acontece Se Eu Perder Rank Antes Do Serviço Ser Concluído?",
        answer: "Os nossos serviços são 100% garantidos. Se surgir algum problema, iremos corrigi-lo rapidamente e garantir que atinjes o rank pretendido."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que queiras jogar Competitivo no mapa associado ao serviço adquirido. No caso de qualquer outro modo ou mapa, basta colocar em pausa ou agendar com o seu booster e se divertir!"
      },
      {
        question: "Posso escolher o horário do meu booster?",
        answer: "Podes. Ao comprar um serviço podes adicionar o teu horário como informação adicional, ou podes clarificar esses e outros detalhes com o booster no chat do serviço."
      },
      {
        question: "Posso pedir o mesmo booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es exactamente un servicio de Boost de Ranking Competitivo CS2?",
        answer: "Un servicio de Boosting Premier es la mejor manera de garantizar que los boosters de primer nivel obtendrán su Clasificación CS deseada."
      },
      {
        question: "¿Puedo jugar con el Booster In Duo mientras hace Boost?",
        answer: "Por supuesto. Para ello, haz clic en el botón rojo \"DUO\" que encontrarás en el menú de añadir pedidos."
      },
      {
        question: "¿Qué pasa si desciendo antes de que termine el servicio?",
        answer: "Nuestros servicios están 100% garantizados. Si surge algún problema, lo solucionaremos rápidamente y nos aseguraremos de que alcanzas tu Rango objetivo."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, a menos que desees jugar Competitivo en el mapa asociado al servicio adquirido. En el caso de cualquier otro modo o mapa, simplemente ponlo en pausa o programa con tus boosters y ¡diviértete!"
      },
      {
        question: "¿Puedo elegir mi horario de booster?",
        answer: "Sí, puedes hacerlo. Cuando realices un pedido puedes añadir tu horario como nota a tu booster, o puedes comentar cualquier detalle con tu booster, incluida la configuración de un horario., en el chat del pedido."
      },
      {
        question: "¿Puedo solicitar al mismo booster para una compra futura?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "Counter Strike 2 | Competitive Rank Boosting Services",
      fr: "Counter Strike 2 | Services de Boosting de Rang Compétitif",
      de: "Counter Strike 2 | Competitive Rank Boosting Services",
      pt: "Counter Strike 2 | Serviços de Boosting de Classificação Competitiva",
      es: "Counter Strike 2 | Servicios de Boost de Ranking Competitivo",
    },
    metaDescription: {
      en: "Rise Counter Strike 2 Competitive Ranks with GGBoost. Opt for the Best and Safest Boosting Services, ensuring Top Tier Performance Every Match",
      fr: "Montez dans les rangs compétitifs de Counter Strike 2 avec GGBoost. Optez pour les meilleurs services de boosting et les plus sûrs, garantissant des performances de haut niveau à chaque match",
      de: "Steige mit GGBoost in die kompetitiven Ränge von Counter Strike 2 auf. Wähle den besten und sichersten Boosting-Service, der dir Höchstleistungen in jedem Match garantiert.",
      pt: "Sube nos Ranks Competitivos de Counter Strike 2 com GGBoost. Opta pelos melhores e mais seguros serviços de boosting, garantindo desempenho de alto nível em cada partida.",
      es: "Sube posiciones en Counter Strike 2 con GGBoost. Opta por los mejores y más seguros servicios de Boosting, garantizando un rendimiento de primer nivel en cada partida.",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        },
      );
    });
  }
}